(($, Drupal, once) => {
  Drupal.behaviors.agendaSearch = {
    attach: function attach(context) {
      once('agendaSearch', '.agenda-search', context).forEach((element) => {
        const eventLit = $(element);
        const img = eventLit.find('.agenda-list__image');
        img.find('img').attr("height", "350").attr("width", "159");
      });
    },
  };

  Drupal.behaviors.actualites = {
    attach: function attach(context) {
      once('actualites', '.actualite-list__masonry', context).forEach((element) => {
        const actualies = $(element);
        const img = actualies.find('img');
        img.attr("height", "350").attr("width", "159");
      });
    },
  };

})(jQuery, Drupal, once);

